import PropTypes from 'prop-types';
import React from 'react';
import TranslatedLink from './TranslatedLink';
import Icons from '../../../../core/modules/common/components/Icons';
import ReportDefinitions from '../../../common/config/ReportDefinitions';

const HeaderTile = (props) => {
  const {
    linkTo,
    value,
    icon,
    onClick,
    showSelectedValue,
    reportName,
  } = props;
  let { title } = props;
  if (title === 'Despatch Type' && ReportDefinitions[reportName].productTypes === 'MAIL_CATEGORY') {
    title = 'Mail Category';
  }
  const currentUrl = window.location.href;
  const lastPath = linkTo && linkTo.slice(linkTo.lastIndexOf('/') + 1);
  const currentUrlLastPath = currentUrl.slice(currentUrl.lastIndexOf('/') + 1);
  const isActive = currentUrlLastPath === lastPath;

  return (
    <TranslatedLink
      className={`wizard-header__tab ${value ? 'has-value' : 'inactive'} ${isActive ? 'active' : ''}`}
      activeclassname="active"
      to={linkTo}
      onClick={onClick}
    >
      <div>
        <div className="wizard-header__tab_icon">
          <Icons.Custom name={icon} />
        </div>

        <div className="wizard-header__tab_text">
          <span className={`tab__title ${showSelectedValue && value ? 'has-value' : ''}`}>
            {title}
          </span>

          {showSelectedValue && value &&
            <span title={value} className="tab__value">{value}</span>
          }
        </div>
      </div>
    </TranslatedLink>
  );
};
export default HeaderTile;

HeaderTile.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  value: PropTypes.string,
  showSelectedValue: PropTypes.bool,
  reportName: PropTypes.string,
};
